export default function Transfers(props) {
  const {t, expenses, averageExpense } = props;

  const filteredExpenses = expenses.filter(ex => ex.sum && !isNaN(ex.sum) && !isNaN(parseInt(ex.sum)));

  // Calculate money transfers needed to equalize expenses
  function getDiffs() {
    return filteredExpenses
        .map(ex => {
          return {
            name: ex.name,
            sum: ex.sum,
            diff: parseInt(ex.sum) - averageExpense
          };
        })
        .filter(d => d.diff !== 0)
        .sort((a, b) => a.diff - b.diff);
  }

  const diffs = getDiffs();

  let transferList = [];
  while (diffs.length > 1 && diffs[0].diff < -1) {
    let giver = diffs[0];
    let taker = diffs.at(-1);
    console.assert(giver.diff < 0);
    console.assert(taker.diff > 0);

    let amount = Math.min(Math.abs(giver.diff), taker.diff);

    console.log(
        `diffs: ${JSON.stringify(diffs, null, 2)} giver ${JSON.stringify(
            giver)} taker ${JSON.stringify(taker)} amount ${amount}`);

    transferList.push({
      from: giver.name,
      to: taker.name,
      amount: Math.round(amount * 100) / 100
    });
    giver.diff += amount;
    taker.diff -= amount;

    console.log(`after: ${JSON.stringify(diffs, null, 2)}`);

    if (giver.diff >= 0) {
      diffs.splice(0, 1);
    }
    if (taker.diff <= 0) {
      diffs.pop();
    }
  }

  const transfersObjs = transferList.map((transfer, index) => (
      <p key={index}>
        {t('transfer', {transfer})}
      </p>
  ));

  return (
      <div className="flex flex-col justify-center items-center my-4">
        <p className="text-xl font-bold">{t("transfers")}</p>
        {transfersObjs.length > 0 ? transfersObjs : <p>{t("no_need")}</p>}
      </div>
  );
}
